import styles from './globe-loading.module.css'
export default function GlobeLoadingStage() {
  return <div className={styles.loading}></div>
}
